// no-restricted-imports it is the only place where it needs to be imported
import { useTranslation as useReactI18NextTranslation } from 'react-i18next'; // eslint-disable-line

import { changeLocale, getAntLocaleConfig } from './locale';
import type { Locale } from './types';
import { useCallback } from 'react';

export function useTranslation() {
  const { t, i18n } = useReactI18NextTranslation();

  const changeLanguage = useCallback(
    (lang: Locale) => {
      i18n.changeLanguage(lang);
      changeLocale(getAntLocaleConfig(lang).locale);
    },
    [i18n],
  );

  return {
    t,
    language: i18n.language,
    changeLanguage,
  };
}

// export type TFunction = ReturnType<typeof tFactory>;
